var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_966_3821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7961 12.9686L11.8749 10.0479C11.7431 9.91611 11.5644 9.84287 11.3769 9.84287H10.8993C11.7079 8.80869 12.1884 7.5082 12.1884 6.09316C12.1884 2.72725 9.46055 0 6.09434 0C2.72813 0 0 2.72725 0 6.09316C0 9.45908 2.72783 12.1863 6.09434 12.1863C7.50938 12.1863 8.81045 11.7059 9.84463 10.8973V11.3748C9.84463 11.5623 9.91787 11.741 10.0497 11.8729L12.9709 14.7935C13.2463 15.0688 13.6916 15.0688 13.9641 14.7935L14.7932 13.9644C15.0686 13.689 15.0686 13.2439 14.7961 12.9686ZM6.09434 10.3113C3.76406 10.3113 1.87559 8.42637 1.87559 6.09316C1.87559 3.76318 3.76084 1.875 6.09434 1.875C8.42461 1.875 10.3131 3.75996 10.3131 6.09316C10.3131 8.42314 8.42783 10.3113 6.09434 10.3113ZM6.09492 3.28125C4.9002 3.28125 3.93164 4.24951 3.93164 5.44424C3.93164 6.40986 5.34551 8.17031 5.88721 8.80928C5.91261 8.83968 5.94438 8.86413 5.98027 8.88091C6.01617 8.89769 6.0553 8.90639 6.09492 8.90639C6.13454 8.90639 6.17368 8.89769 6.20957 8.88091C6.24546 8.86413 6.27723 8.83968 6.30264 8.80928C6.84434 8.17031 8.2582 6.41016 8.2582 5.44424C8.2582 4.24951 7.28965 3.28125 6.09492 3.28125ZM6.09492 6.09375C5.70645 6.09375 5.3918 5.77881 5.3918 5.39062C5.3918 5.00215 5.70674 4.6875 6.09492 4.6875C6.48311 4.6875 6.79805 5.00215 6.79805 5.39062C6.79805 5.77881 6.48311 6.09375 6.09492 6.09375Z",
    fill: "#808282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_966_3821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLocation);
export default __webpack_public_path__ + "static/media/SearchLocation.92eee1e727732025802fb1e11e2c260a.svg";
export { ForwardRef as ReactComponent };